export default __webpack_public_path__ + "static/media/completed-icon.dca47a31.svg";